import { MOTIVO_MINIMO } from '@/lib/motivo';

/**
 * O contador do motivo (R06, p.69): "42 de 10" — os caracteres escritos (sem
 * os espaços das pontas) contra o piso.
 */
export function contadorDoMotivo(motivo: string, minimo: number = MOTIVO_MINIMO): { readonly texto: string; readonly cumpre: boolean } {
  const n = motivo.trim().length;
  return { texto: `${String(n)} de ${String(minimo)}`, cumpre: n >= minimo };
}
